import React from 'react';
import { Table, Button } from 'antd';

const TableWithLoadMore = ({ columns, data, isShowMore, onLoadMore, loading, rowKey, className, rowClassName, numRows }) => {
  const handleLoadMore = (e) => {
    e.preventDefault();
    onLoadMore();
  };

  return (
    <>
      <div className="gx-table-responsive">
        <Table
          rowClassName={(r, i) => rowClassName(r, i)}
          rowKey={rowKey}
          className={`gx-table-no-bordered ${className}`}
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered={false}
          size='small'
          loading={loading}
        />
      </div>
      <div className='load-more'>
        <div className='gx-text-primary'>Số dữ liệu hiện tại: { data.length > 0 ? numRows : 0 }</div>
        {isShowMore && <Button icon='arrow-down' disabled={loading} onClick={handleLoadMore}>Tải thêm dữ liệu</Button>}
      </div>
    </>
  );
};
export default TableWithLoadMore;
